exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-5a648d17]{padding:0}.fa[data-v-5a648d17]{color:#fffacd;margin:10px}.fa-2x[data-v-5a648d17]{font-size:2em!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a648d17","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/TheFooter.vue
// module id = 185
// module chunks = 20